import React, { CSSProperties, FunctionComponent, HTMLAttributes, useState } from 'react'
import styles from './Group.module.sass'
import clsx from 'clsx'
import { hoverContext } from '../../../constants/contexts'

const padding = parseInt(styles.padding)

export interface GroupProps extends HTMLAttributes<HTMLDivElement> {
    className?: string,
    headerClassName?: string,
    header: JSX.Element,
    headerHeight: number,
    headerLeft?: number,
}

const Group: FunctionComponent<GroupProps> = ({ className, header, headerHeight, headerLeft, children, ...props }) => {
    const [hover, setHover] = useState(false)

    return <div
        {...props}
        style={{
            ...props.style,
            '--margin-top': `${headerHeight / 2}px`,
            '--padding': `${Math.max(padding, headerHeight / 2) + 2}px`,
        } as CSSProperties}
        className={clsx(className, styles.group)}
        onMouseEnter={event => {
            props.onMouseEnter?.(event)
            setHover(true)
        }}
        onMouseLeave={event => {
            props.onMouseLeave?.(event)
            setHover(false)
        }}
    >
        <hoverContext.Provider value={hover}>
            <div
                className={clsx(props.headerClassName, styles.header)}
                style={{
                    top: -headerHeight / 2,
                    left: headerLeft,
                }}
            >
                {header}
            </div>
            {
                children
            }
        </hoverContext.Provider>
    </div>
}

export default Group